import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useGetStateQuery } from "../../redux/services/stateService/state.Services";
import { useGetCityQuery } from "../../redux/services/cityService/city.Services";
import { useCreateCityMutation } from "../../redux/services/cityService/city.Services";

import { successToast, errorToast } from "../../Utils/toast";

function AddFaq() {
    const navigate = useNavigate();
    const {
        data,
        isLoading,
        error
    } = useGetStateQuery({});
    const stateData = data?.data || [];
    const [createCity, { isLoading: cityLoading }] =
        useCreateCityMutation();
    const [formData, setFormData] = useState({
        state_id: "",
        name: "",
        status: "active",
    });
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // HANDLE SUBMIT
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response =
                await createCity(formData).unwrap();
            successToast(response?.message);
            navigate(-1);

        } catch (error) {

            console.log(error);

            errorToast(
                error?.data?.message || "Failed"
            );
        }
    };

    return (

        <div>

            {/* HEADER */}
            <div className="page-header-breadcrumb all_breadcrumb">

                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">

                    <nav>

                        <h4 className="fw-semibold">
                            Add City
                        </h4>

                        <ol className="breadcrumb mb-0">

                            <li className="breadcrumb-item">
                                <Link to="/">
                                    Home
                                </Link>
                            </li>

                            <li
                                className="breadcrumb-item active"
                                aria-current="page"
                            >
                                Add City
                            </li>

                        </ol>

                    </nav>

                </div>
                <div className="page-title fw-semibold fs-18 mb-0">

                    <button
                        className="btn btn-primary me-2"
                        onClick={() => navigate(-1)}
                    >

                        <span>
                            <i className="fe fe-shopping-cart me-1"></i>
                        </span>

                        City List

                    </button>

                </div>

            </div>

            {/* FORM */}
            <div className="card">

                <div className="card-body">

                    <form onSubmit={handleSubmit}>

                        <div className="row g-4 align-items-end">

                            {/* STATE */}
                            <div className="col-md-6">

                                <div className="city-form-group">

                                    <label className="form-label">
                                        Select State
                                    </label>

                                    <select
                                        name="state_id"
                                        value={formData.state_id}
                                        onChange={handleChange}
                                        className="form-control custumform"
                                    >

                                        <option value="">
                                            Select State
                                        </option>

                                        {
                                            stateData.map((item) => (

                                                <option
                                                    key={item.id}
                                                    value={item.id}
                                                >
                                                    {item.name}
                                                </option>

                                            ))
                                        }

                                    </select>

                                </div>

                            </div>

                            {/* CITY NAME */}
                            <div className="col-md-6">

                                <div className="city-form-group">

                                    <label className="form-label">
                                        Enter City Name
                                    </label>

                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        className="form-control custumform"
                                        placeholder="Enter city name"
                                    />

                                </div>

                            </div>

                            {/* STATUS */}
                            <div className="col-md-6">

                                <div className="city-form-group">

                                    <label className="form-label">
                                        Status
                                    </label>

                                    <select
                                        name="status"
                                        value={formData.status}
                                        onChange={handleChange}
                                        className="form-control custumform"
                                    >

                                        <option value="active">
                                            Active
                                        </option>

                                        <option value="inactive">
                                            Inactive
                                        </option>

                                    </select>

                                </div>

                            </div>

                            {/* BUTTON */}
                            <div className="col-12">

                                <div className="d-flex justify-content-end">

                                    <div className="button_submit">

                                        <button type="submit">

                                            {
                                                isLoading
                                                    ? "Loading..."
                                                    : "Submit City"
                                            }

                                        </button>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </form>

                </div>

            </div>

        </div>
    );
}

export default AddFaq;